module.exports = __webpack_public_path__ + "media/mobility_spms_cane.mp4";